import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import qr from "../../image/qr.png";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import moment from "moment";
import scan_check_green from "../../image/scan_check_green.png";
import wrongicon from "../../image/wrongicon.png";
import scan_unchecked_red from "../../image/scan_unchecked_red.png";
import { confirmAlert } from "react-confirm-alert";
import QRCode from "qrcode";
import { authUserData } from "../../utils/Helper";
const PickupPointPackage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pickupPointList, setpickupPointList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const { Option } = Select;
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const hasPermission = authUserData()?.group[0]?.name;
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getpickupPointList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          "pickup-point/package-by-pickup-point/",
          state
        );
        console.log("Responsse", apiResponse);
        if (apiResponse?.data?.success) {
          setpickupPointList(apiResponse?.data?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_pickuppoint_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getpickupPointList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };
  const handleResidentSelectChange = async (id, status) => {
    setLoading(true);
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("confirmAlert_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => {
            setLoading(false);
            navigate("/package");
          },
        },
      ],
    });
  };
  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "additional_detail" && sortOrder === "ascend") {
      sortingEnumKey = "additional_detail";
    }
    if (sortField === "additional_detail" && sortOrder === "descend") {
      sortingEnumKey = "-additional_detail";
    }
    if (sortField === "pincode" && sortOrder === "ascend") {
      sortingEnumKey = "pincode";
    }
    if (sortField === "pincode" && sortOrder === "descend") {
      sortingEnumKey = "-pincode";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb";
    }

    if (sortField === "address" && sortOrder === "ascend") {
      sortingEnumKey = "address";
    }
    if (sortField === "address" && sortOrder === "descend") {
      sortingEnumKey = "-address";
    }

    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }

    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "person_name" && sortOrder === "ascend") {
      sortingEnumKey = "person_name";
    }
    if (sortField === "person_name" && sortOrder === "descend") {
      sortingEnumKey = "-person_name";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state";
    }
    return sortingEnumKey;
  };

  const handleQRDownload = async (secretKey) => {
    try {
      // Generate QR code as a data URL (base64 PNG)
      const dataUrl = await QRCode.toDataURL(secretKey, {
        width: 300, // Set width
        margin: 2, // Set margin
      });

      // Create a link to trigger the download
      const downloadLink = document.createElement("a");
      downloadLink.href = dataUrl;
      downloadLink.download = "QRCode.png"; // File name
      downloadLink.click();
    } catch (err) {
      console.error("Error generating QR code:", err);
    }
  };
  // const handleQRDownload = async (secretKey) => {
  //   const endpoint = `pickup-point/download-qr-code/`;
  //   const fileType = "png"; // File type for QR code

  //   const payload = {
  //     uniq_id: secretKey,
  //   };

  //   try {
  //     const response = await postRequest(endpoint, payload);

  //     // Check if response contains Base64 string or binary data
  //     if (
  //       typeof response.data === "string" &&
  //       response.data.startsWith("data:image")
  //     ) {
  //       // Base64 image string
  //       const link = document.createElement("a");
  //       link.href = response.data;
  //       link.download = `QRCode_${secretKey}.${fileType}`;
  //       link.click();
  //     } else {
  //       // Handle binary data
  //       const blob = new Blob([response.data], { type: `image/${fileType}` });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `QRCode_${secretKey}.${fileType}`;
  //       link.click();
  //       window.URL.revokeObjectURL(link.href);
  //     }
  //   } catch (error) {
  //     console.error("Error downloading QR Code:", error);
  //   }
  // };

  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_pickup_point_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/pickup-point"),
        },
      ],
    });
  };

  const changeStatus = async (id, value) => {
    setLoading(true);
    await postRequest(
      `status-change-by-pickup-point-person/update-package-status/`,
      { package_id: id, status: value }
    )
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        // Use a function updater for setReload to reliably toggle the reload state
        setReload((prevReload) => !prevReload);
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
        console.error("Error updating status:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [checkedList, setCheckedList] = useState([
    "parcel_no",
    "created_at",
    "customer_phone",
    "customer_email",
    "is_scanned",
    "suburb",
    "status",
    "zone",
    "state",
    "postcode",
    "assigned_to",
    "hawb",
    "unrouted",
    "sequence_no",
    "customer_code",
    "customer_name",
    "company",
    "customer_address",
    "description_of_goods",
    "count",
    "landed",
    "weight",
    "shipper_code",
    "shipper_name",
    "shipper_address",
    "shipper_city",
    "shipper_state",
    "shipper_postcode",
    "shipper_country",
    "origin",
    "port",
    "total_value",
    "goods_currency",
    "sac",
    "fr_reference",
    "sub_master",
    "pkg_type",
    "cyber_vendor_account",
    "customs_code",
    "operation",
  ]);
  const allColumns = [
    { key: "parcel_no", title: "Parcel Number" },
    { key: "created_at", title: "Schedule Date" },
    { key: "hawb", title: "HAWB" },
    { key: "unrouted", title: "Unrouted" },
    { key: "sequence_no", title: "Sequence" },
    { key: "is_scanned", title: "Is Scanned" },
    { key: "status", title: "Status" },
    { key: "suburb", title: "Suburb" },
    { key: "zone", title: "Zone" },
    { key: "state", title: "State" },
    { key: "postcode", title: "Postcode" },
    { key: "assigned_to", title: "Assigned Driver" },

    { key: "customer_code", title: "Customer Code" },
    { key: "customer_name", title: "Customer Name" },
    { key: "company", title: "Company" },

    { key: "customer_phone", title: "Customer phone" },
    { key: "customer_email", title: "Customer Email" },
    { key: "customer_address", title: "Customer Address" },
    { key: "description_of_goods", title: "Description of Goods" },
    { key: "count", title: "Count" },
    { key: "landed", title: "Landed" },
    { key: "weight", title: "Weight" },
    { key: "shipper_code", title: "Shipper Code" },
    { key: "shipper_name", title: "Shipper Name" },
    { key: "shipper_address", title: "Shipper Address" },
    { key: "shipper_city", title: "Shipper City" },
    { key: "shipper_state", title: "Shipper State" },
    { key: "shipper_postcode", title: "Shipper Postcode" },
    { key: "shipper_country", title: "Shipper Country" },
    { key: "origin", title: "Origin" },
    { key: "port", title: "Port" },
    { key: "total_value", title: "Total Value" },
    { key: "goods_currency", title: "Goods Currency" },
    { key: "sac", title: "SAC" },
    { key: "fr_reference", title: "FR Reference" },
    { key: "sub_master", title: "Sub Master" },
    { key: "pkg_type", title: "Package Type" },
    { key: "cyber_vendor_account", title: "Cyber Vendor Account" },
    { key: "customs_code", title: "Customs Code" },
    { key: "operation", title: "Action" },
  ];
  useEffect(() => {
    const updatedColumns = [
      // Define columns here
      {
        title: "Parcel Number",
        dataIndex: "parcel_no",
        key: "parcel_no",
        sorter: true,
        width: 100,
      },
      {
        title: "Sequence",
        dataIndex: "sequence_no",
        key: "sequence_no",
        sorter: true,
        width: 150,
        render: (text) => (
          <div className="text-ellipsis">
            {text !== undefined && text !== null ? text : 0}
          </div>
        ),
      },
      {
        title: "HAWB",
        dataIndex: "hawb",
        key: "hawb",
        sorter: true,

        width: 200,
      },

      {
        title: "Schedule Date",
        dataIndex: "created_at",
        key: "created_at",
        sorter: true,
        width: 150,
        render: (text) => (
          // <Tooltip title={text}>
          //   <div className="text-ellipsis">
          //     {moment(text).format("DD-MM-YYYY")}
          //   </div>
          // </Tooltip>
          // <Tooltip title={text}>
          <div className="text-ellipsis">
            {text ? moment(text, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY") : "-"}
          </div>
          //   </Tooltip>
        ),
      },

      // {
      //   title: "Is Scanned",
      //   dataIndex: "is_scanned",
      //   key: "is_scanned",
      //   sorter: true,
      //   width: 120,
      //   render: (text) => (

      //     <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
      //   ),
      // },
      {
        title: "Is Scanned",
        dataIndex: "is_scanned",
        key: "is_scanned",
        sorter: true,
        width: 120,
        render: (text) => (
          <div className="text-ellipsis">
            {text ? (
              <img
                src={scan_check_green} // Replace with the actual path to the 'Yes' image
                alt="Yes"
                style={{ width: 20, height: 20, Color: "rgba(0, 128, 0, 0.5)" }}
              />
            ) : (
              <img
                src={scan_unchecked_red} // Replace with the actual path to the 'No' image
                alt="No"
                style={{ width: 20, height: 20 }}
              />
            )}
          </div>
        ),
      },
      ...(hasPermission === "Pickup Point Manager"
        ? [] // If CompanyId exists, exclude this column
        : [
            {
              title: "Unrouted",
              dataIndex: "unrouted",
              key: "unrouted",
              sorter: true,
              width: 180,
              render: (text) => (
                <div className="text-ellipsis">
                  {text ? (
                    <img
                      src={wrongicon} // Replace with the actual path to the 'Yes' image
                      alt="Yes"
                      style={{
                        width: 20,
                        height: 20,
                        Color: "rgba(0, 128, 0, 0.5)",
                      }}
                    />
                  ) : (
                    // <img
                    //   src={scan_unchecked_red} // Replace with the actual path to the 'No' image
                    //   alt="No"
                    //   style={{ width: 20, height: 20 }}
                    // />
                    "-"
                  )}
                </div>
              ),
            },
          ]),
      {
        title: "Suburb",
        dataIndex: "suburb_name",
        key: "suburb",
        sorter: true,
        width: 180,
      },
      {
        title: "Run",
        dataIndex: "zone_name",
        key: "zone",
        sorter: true,
        width: 180,
      },
      {
        title: "State",
        dataIndex: "state_name",
        key: "state",
        sorter: true,
        width: 150,
      },
      {
        title: "Postcode",
        dataIndex: "postcode_name",
        key: "postcode",
        sorter: true,
        width: 150,
      },
      {
        title: "Company",
        dataIndex: "company_name",
        key: "company",
        sorter: true,
        width: 150,
      },
      // {
      //   title: "Assigned Driver",
      //   dataIndex: "assigned_to",
      //   key: "assigned_to",
      //   sorter: true,
      //   width: 200,
      //   render: (assigned_to, record) => (
      //     <DriverAssignment
      //       record={record}
      //       reload={reload}
      //       setSelectedRow={setSelectedRow}
      //       setRouteIds={setRouteIds}
      //       routeIds={routeIds}
      //       setReload={setReload}
      //       setState={setState}
      //       driverList={driverList}
      //       setEmployeeList={setEmployeeList}
      //     />
      //   ),
      // },
      // {
      //   title: "Assigned Driver",
      //   dataIndex: "assigned_to",
      //   key: "assigned_to",
      //   sorter: true,
      //   width: 200,
      //   render: (assigned_to, record) => {
      //     // Check if CompanyId exists and is truthy
      //     if (CompanyId) {
      //       return null; // Return null (nothing will be rendered) if no CompanyId
      //     }

      //     // Otherwise, render DriverAssignment component
      //     return (
      //       <DriverAssignment
      //         record={record}
      //         reload={reload}
      //         setSelectedRow={setSelectedRow}
      //         setRouteIds={setRouteIds}
      //         routeIds={routeIds}
      //         setReload={setReload}
      //         setState={setState}
      //         driverList={driverList}
      //         setEmployeeList={setEmployeeList}
      //       />
      //     );
      //   },
      // },

      ...(hasPermission === "Company Admin" ||
      hasPermission === "Pickup Point Manager"
        ? [] // If CompanyId exists, exclude this column
        : [
            // {
            //   title: "Assigned Driver",
            //   dataIndex: "assigned_to",
            //   key: "assigned_to",
            //   sorter: true,
            //   width: 200,
            //   render: (assigned_to, record) => {
            //     return (
            //       <DriverAssignment
            //         record={record}
            //         reload={reload}
            //         setSelectedRow={setSelectedRow}
            //         setRouteIds={setRouteIds}
            //         routeIds={routeIds}
            //         setReload={setReload}
            //         setState={setState}
            //         driverList={driverList}
            //         setEmployeeList={setEmployeeList}
            //       />
            //     );
            //   },
            // },
          ]),

      // Add more columns as needed...

      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: true,
        width: 230,
        render: (e, record) => (
          <div>
            <Select
              disabled={hasPermission === "Company Admin"}
              value={e ? e : record.status}
              className="gridselect"
              onChange={(e) => handleResidentSelectChange(record.id, e)}
              defaultValue={e}
              placeholder={t("pl_select_status")}
            >
              <Option key="Not Scanned" value="Not Scanned">
                Not Scanned
              </Option>
              <Option key="Received in Depo" value="Received in Depo">
                Received in Depo
              </Option>
              <Option key="Loaded by Driver" value="Loaded by Driver">
                Loaded by Driver
              </Option>
              <Option key="In Transit" value="In Transit">
                In Transit
              </Option>
              <Option key="Delivered" value="Delivered">
                Delivered
              </Option>
              <Option key="Failed Delivery" value="Failed Delivery">
                Failed Delivery
              </Option>
              <Option
                key="Received at Pickup Point"
                value="Received at Pickup Point"
              >
                Received at Pickup Point
              </Option>
              <Option key="RTS- Return to Sender" value="RTS- Return to Sender">
                RTS- Return to Sender
              </Option>
              <Option key="RD- Return to depo" value="RD- Return to depo">
                RD- Return to depo
              </Option>
            </Select>
          </div>
        ),
      },

      {
        title: "Customer Code",
        dataIndex: "customer_code",
        key: "customer_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Name",
        dataIndex: "customer_name",
        key: "customer_name",
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Phone",
        dataIndex: "customer_phone",
        key: "customer_phone",
        // render: (customer_phone) => <>+{customer_phone} </>,
        render: (customer_phone) =>
          customer_phone ? <>+{customer_phone}</> : null,
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Email",
        dataIndex: "customer_email",
        key: "customer_email",
        sorter: true,
        width: 200,
        // render: (text) => (
        //   <Tooltip title={text}>
        //     <span>{text}</span>
        //   </Tooltip>
        // ),
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textTransform: "none",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Customer Address",
        dataIndex: "customer_address",
        key: "customer_address",
        sorter: true,
        width: 200,
        // render: (text) => (
        //   <Tooltip title={text}>
        //     <span>{text}</span>
        //   </Tooltip>
        // ),
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },

      {
        title: "Description of Goods",
        dataIndex: "description_of_goods",
        key: "description_of_goods",
        sorter: true,
        width: 150,
      },
      {
        title: "Count",
        dataIndex: "count",
        key: "count",
        sorter: true,
        width: 100,
      },
      {
        title: "Landed",
        dataIndex: "landed",
        key: "landed",
        sorter: true,
        width: 100,
        render: (text) => (
          <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
        ),
      },
      {
        title: "Weight",
        dataIndex: "weight",
        key: "weight",
        sorter: true,
        width: 100,
      },
      {
        title: "Shipper Code",
        dataIndex: "shipper_code",
        key: "shipper_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Name",
        dataIndex: "shipper_name",
        key: "shipper_name",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Shipper Address",
        dataIndex: "shipper_address",
        key: "shipper_address",
        sorter: true,
        width: 200,
        // render: (text) => (
        //   <Tooltip title={text}>
        //     <span>{text}</span>
        //   </Tooltip>
        // ),
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Shipper City",
        dataIndex: "shipper_city",
        key: "shipper_city",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper State",
        dataIndex: "shipper_state",
        key: "shipper_state",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Postcode",
        dataIndex: "shipper_postcode",
        key: "shipper_postcode",
        sorter: true,
        width: 100,
      },
      {
        title: "Shipper Country",
        dataIndex: "shipper_country",
        key: "shipper_country",
        sorter: true,
        width: 150,
      },
      {
        title: "Origin",
        dataIndex: "origin",
        key: "origin",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Port",
        dataIndex: "port",
        key: "port",
        sorter: true,
        width: 150,
      },
      {
        title: "Total Value",
        dataIndex: "total_value",
        key: "total_value",
        sorter: true,
        width: 150,
      },
      {
        title: "Goods Currency",
        dataIndex: "goods_currency",
        key: "goods_currency",
        sorter: true,
        width: 100,
      },
      {
        title: "SAC",
        dataIndex: "sac",
        key: "sac",
        sorter: true,
        width: 100,
        render: (text) => (
          <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
        ),
      },
      {
        title: "FR Reference",
        dataIndex: "fr_reference",
        key: "fr_reference",
        sorter: true,
        width: 150,
      },
      {
        title: "Sub Master",
        dataIndex: "sub_master",
        key: "sub_master",
        sorter: true,
        width: 150,
      },
      {
        title: "Package Type",
        dataIndex: "pkg_type",
        key: "pkg_type",
        sorter: true,
        width: 100,
      },
      {
        title: "Cyber Vendor Account",
        dataIndex: "cyber_vendor_account",
        key: "cyber_vendor_account",
        sorter: true,
        width: 150,
      },
      {
        title: "Customs Code",
        dataIndex: "customs_code",
        key: "customs_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 130,
        render: (text, record) => (
          <Space>
            {/* <Tooltip
              color={colors}
              placement="left"
              title={<span style={{ color: "#fff" }}>Edit</span>}
            > */}
            {authUserData()?.permission.includes(
              "package|change_packagemodel"
            ) && (
              <Link to={`/package/edit/${btoa(record.id)}`}>
                <Editicon onClick={() => handleEdit(record.id)} />
              </Link>
            )}
            {/* </Tooltip> */}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={<span style={{ color: "#fff" }}>Archive</span>}
            > */}
            {authUserData()?.permission.includes(
              "package|delete_packagemodel"
            ) && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                onConfirm={() => handleArchive(record.id)}
              >
                <Archive style={{ cursor: "pointer" }} />
              </Popconfirm>
            )}
            {/* </Tooltip> */}
          </Space>
        ),
      },
    ].filter((column) => checkedList.includes(column.key));

    setColumns(updatedColumns);
  }, [checkedList]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleArchive = async (id = []) => {
    let ids = [...selectedRow];

    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest(
        "pickup-point/archive-pickup-point/",
        {
          deleted: ids,
        }
      );
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("pickuppoint_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const handleEdit = (id) => {};

  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & manage the list of company within the organization.
                </span>
              }
            > */}
            <h3>Pickup Point Packages</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Pickup Point Packages")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            >
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={() => navigate("/pickup-point/add")}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("Add Pickup Point")}
              </Button>
            </Tooltip> */}

            {/* {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_archive")}
                />
              </Popconfirm>
            )} */}
            {/* <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/pickup-point/archive">
                <Archiveicon />
              </Link>
            </Tooltip> */}
            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="PR-body">
          <Table
            rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={pickupPointList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
        </div>
      </section>
    </>
  );
};
export default PickupPointPackage;
